module.exports = __webpack_public_path__ + "static/img/JGArchitecture_元生_image@2x.b455c5ab.png";